import React from 'react';
import Modal from 'react-modal';
import { useTranslation } from "react-i18next";

const customStyles = {
    content: {
        top: '50%', left: '50%', right: 'auto', bottom: 'auto',
        marginRight: '-50%', transform: 'translate(-50%, -50%)',
        width: '95%', maxWidth: '800px', maxHeight: '90vh',
        overflowY: 'auto', padding: '30px', borderRadius: '12px', border: 'none',
        boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
    },
    overlay: { backgroundColor: 'rgba(0, 0, 0, 0.75)', zIndex: 1000 }
};

const SuggestCaseViewModal = ({ modalIsOpen, closeModal, data }) => {
    const { t } = useTranslation();

    if (!data) return null;

    const isVision = !!data.question_name;

    return (
        <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles}>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <h4 className="m-0 font-weight-bold text-primary text-uppercase" style={{ letterSpacing: '1px' }}>
                    {t('general.suggest.form.modal-title-suggest')}
                </h4>
                <button onClick={closeModal} className="btn-close" style={{ border: 'none', background: 'none', fontSize: '1.8rem', color: '#666' }}>&times;</button>
            </div>
            <hr className="mt-1 mb-4" />

            <div className="container-fluid p-0" style={{ fontSize: '0.95rem', color: '#333' }}>

                {/* (1) Módulo - Usando las nuevas claves de la imagen */}
                <div className="mb-3">
                    <label className="d-block mb-0 title-modal-suggest-case">{t('general.suggest.form.modal-module')}</label>
                    <span className="text-modal-suggest-case">
                        {t(`general.suggest.form-${data.CatalogModule_To_SuggestCase?.key}`)}
                    </span>
                </div>

                {isVision ? (
                    <div className="mb-3">
                        <label className="d-block mb-0 title-modal-suggest-case">{t('general.suggest.form.modal-name-vision')}</label>
                        <span className="text-modal-suggest-case">{data.question_name}</span>
                    </div>
                ) : (
                    <>
                        <div className="mb-3">
                            <label className="d-block mb-0 title-modal-suggest-case">{t('general.suggest.form.modal-name-normal')}</label>
                            <span className="text-modal-suggest-case">{data.case_name}</span>
                        </div>
                        <div className="mb-3">
                            <label className="d-block mb-0 title-modal-suggest-case">{t('general.suggest.form.modal-sector')}</label>
                            <span className="text-modal-suggest-case">{data.CatalogCiiu_To_SuggestCase?.name || 'N/A'}</span>
                        </div>
                        <div className="mb-3">
                            <label className="d-block mb-0 title-modal-suggest-case">{t('general.suggest.form.modal-country')}</label>
                            <span className="text-modal-suggest-case">{data.CatalogCountry_To_SuggestCase?.name || 'N/A'}</span>
                        </div>

                        {/* (5) Entidad Generadora */}
                        <div className="mt-4 pt-2 border-top">
                            <label className="d-block mb-2 title-modal-suggest-case">{t('general.suggest.form.modal-entity-generator')}</label>
                            <div className="row small">
                                <div className="col-md-6"><strong>{t('general.suggest.form.modal-name')}:</strong> {data.entity_gen_name || 'N/A'}</div>
                                <div className="col-md-6"><strong>{t('general.suggest.form.modal-email')}:</strong> {data.entity_gen_email || 'N/A'}</div>
                                <div className="col-md-6"><strong>{t('general.suggest.form.modal-web')}:</strong> {data.entity_gen_web || 'N/A'}</div>
                                <div className="col-md-6"><strong>{t('general.suggest.form.modal-phone')}:</strong> {data.entity_gen_phone || 'N/A'}</div>
                            </div>
                        </div>

                        <div className="mt-3">
                            <label className="d-block mb-0 title-modal-suggest-case">{t('general.suggest.form.modal-url')}</label>
                            <a href={data.case_url} target="_blank" rel="noreferrer" className="text-primary">{data.case_url || 'N/A'}</a>
                        </div>

                        {/* (7) Datos del Medio */}
                        <div className="mt-4 pt-2 border-top">
                            <label className="d-block mb-2 title-modal-suggest-case">{t('general.suggest.form.modal-identity-media')}</label>
                            <div className="row small">
                                <div className="col-md-6"><strong>{t('general.suggest.form.modal-type')}:</strong> {data.CatalogMediaType_To_SuggestCase?.name || 'N/A'}</div>
                                <div className="col-md-6"><strong>{t('general.suggest.form.modal-media-name')}:</strong> {data.media_name || 'N/A'}</div>
                                <div className="col-md-6"><strong>{t('general.suggest.form.modal-date')}:</strong> {data.media_date || 'N/A'}</div>
                                <div className="col-md-6"><strong>{t('general.suggest.form.modal-location')}:</strong> {data.CatalogMediaCountry_To_SuggestCase?.name || 'N/A'} - {data.media_city || 'N/A'}</div>
                            </div>
                        </div>

                    </>
                )}

                {/* (8) Persona que remite */}
                <div className="mt-4 pt-2 border-top mb-4">
                    <label className="font-weight-bold d-block mb-2 title-modal-suggest-case">{!isVision ? t('general.suggest.form.person-institution') : t('general.suggest.form.person-institution-vision')}</label>
                    <div className="row small">
                        <div className="col-md-4"><strong>{t('general.suggest.form.modal-name')}:</strong> {data.sender_name}</div>
                        <div className="col-md-4"><strong>{t('general.suggest.form.modal-email')}:</strong> {data.sender_email}</div>
                        <div className="col-md-4"><strong>{t('general.suggest.form.modal-phone')}:</strong> {data.sender_phone || 'N/A'}</div>
                    </div>
                </div>
            </div>

            <div className="text-right">
                <button className="btn btn-secondary px-4 shadow-sm" onClick={closeModal}>
                    {t('general.suggest.form.modal-button-close')}
                </button>
            </div>
        </Modal>
    );
};

export default SuggestCaseViewModal;